export default __webpack_public_path__ + "static/media/password.b5ad9e0e.svg";